import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "⚠️ Supabase URL ou Anon Key não configurados. Verifique as variáveis de ambiente.",
  );
}

/* Configuração do cliente Supabase
- Usamos o schema 'public' para todas as operações
- Configurações de autenticação para manter sessão ativa e detectar mudanças
- Headers globais para garantir que todas as requisições sejam JSON
*
*/

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: "public",
  },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
  global: {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  },
});

// Tipos para o banco de dados
export interface Usuario {
  id: string;
  email: string;
  nome_completo: string;
  empresa: string;
  cnpj?: string;
  cargo?: string;
  tipo_usuario:
    | "admin"
    | "usuario"
    | "gestor"
    | "BASICO"
    | "PROFISSIONAL"
    | "ENTERPRISE"
    | "SUPER_ADMIN";
  ativo: boolean;
  data_termino_mandato?: string;
  ultimo_acesso?: string;
  created_at: string;
  updated_at: string;
}

export interface AuthResponse {
  success: boolean;
  user?: Usuario;
  error?: string;
}
